export function setCookie(name: string, value: string | null = null, days: number = 60, path: string = '/') {
    if (!value) return removeCookie(name, path);
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=${path}; SameSite=none; Secure=true;`;
}

export function removeCookie(name: string, path: string = '/') {
    document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function getCookie(name: string) {
    return document.cookie
      .split(";")
      .find((row) => row.trim().startsWith(`${name}=`))
      ?.split("=")[1] ?? "";
}

export function isCookieValid(name: string): boolean {
    const cookie = getCookie(name);
    return !!cookie;
}
